import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    provider_list: []
  };
  
  const providerStateSlice = createSlice({
    name: 'provider',
    initialState: initialState,
    reducers: {
      listProvider: (state, action) => {
        state.provider_list= action.payload 
      }
    }
  });
  
  export const { listProvider } = providerStateSlice.actions;
  
  export default providerStateSlice.reducer;